import { createAsyncThunk } from '@reduxjs/toolkit';
import chevron from '@/services/chevron';
import { isNetworkError } from '@/utils/helperFunc';
import { showToast } from '../notifications/slice';

export const fetchFeatureFlags = createAsyncThunk<string[]>(
  'featureFlags/fetchFeatureFlags',
  async (_, { dispatch }) => {
    const localOverrideFlags = import.meta.env.DEV
      ? String(import.meta.env.VITE_FEATURE_FLAGS_LOCAL_OVERRIDE ?? '')
          .split(',')
          .map((flag) => flag.trim())
          .filter(Boolean)
      : [];

    const url = `${import.meta.env.VITE_API_MAIN_APP}/features/list`;
    try {
      const response = (await chevron.http({
        url,
        method: 'GET',
      })) as string[];

      return Array.from(new Set([...(response || []), ...localOverrideFlags]));
    } catch (error) {
      // Keep local dev overrides usable even when feature-flags API is unreachable.
      if (localOverrideFlags.length > 0) {
        return localOverrideFlags;
      }

      const isNetworkErr = isNetworkError(error);

      if (isNetworkErr) {
        // For network errors, show a toast but the global error page will also show
        dispatch(showToast({ text: 'Cannot reload. Check connection.', state: 'warning' }));
      } else {
        // For non-network errors, show error toast
        dispatch(showToast({ text: 'Error fetching data. Please refresh', state: 'error' }));
      }
      throw error;
    }
  },
);
